module.exports = __webpack_public_path__ + "static/img/paysuc-icon.f23874f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paysuc-icon.png
// module id = +NZ0
// module chunks = 1